var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisponivelGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "artwork",
    x: 0,
    y: 0,
    viewBox: "0 0 135.7 41.3",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 135.7 41.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#fff;fill-opacity:0}.st1{fill:#a6a6a6}.st2{fill:#fff}.st3{fill:url(#SVGID_1_)}.st4{fill:url(#SVGID_2_)}.st5{fill:url(#SVGID_3_)}.st6{fill:url(#SVGID_4_)}.st7,.st8,.st9{opacity:.2;enable-background:new}.st8,.st9{opacity:.12}.st9{opacity:.25;fill:#fff}.st10{fill:#fff;stroke:#fff;stroke-width:.2;stroke-miterlimit:10}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -9.8,
    y: -9.3,
    className: "st0",
    width: 155,
    height: 60
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130.2,40.7H5.2c-2.8,0-5-2.2-5-5v-30c0-2.8,2.2-5,5-5h125c2.8,0,5,2.2,5,5v30C135.2,38.4,132.9,40.7,130.2,40.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.2,1.5c2.3,0,4.2,1.9,4.2,4.2v30c0,2.3-1.9,4.2-4.2,4.2H5.2C2.9,39.9,1,38,1,35.7v-30 c0-2.3,1.9-4.2,4.2-4.2H130.2 M130.2,0.7H5.2c-2.8,0-5,2.2-5,5v30c0,2.8,2.2,5,5,5h125c2.8,0,5-2.2,5-5v-30 C135.2,2.9,132.9,0.7,130.2,0.7L130.2,0.7z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.3,22.4c-2.4,0-4.3,1.8-4.3,4.3c0,2.4,1.9,4.3,4.3,4.3c2.4,0,4.3-1.8,4.3-4.3 C72.6,24.2,70.7,22.4,68.3,22.4z M68.3,29.2c-1.3,0-2.4-1.1-2.4-2.6c0-1.5,1.1-2.6,2.4-2.6s2.4,1,2.4,2.6 C70.7,28.2,69.6,29.2,68.3,29.2z M59,22.4c-2.4,0-4.3,1.8-4.3,4.3c0,2.4,1.9,4.3,4.3,4.3c2.4,0,4.3-1.8,4.3-4.3 C63.3,24.2,61.3,22.4,59,22.4z M59,29.2c-1.3,0-2.4-1.1-2.4-2.6c0-1.5,1.1-2.6,2.4-2.6c1.3,0,2.4,1,2.4,2.6 C61.4,28.2,60.3,29.2,59,29.2z M47.9,23.7v1.8h4.3c-0.1,1-0.5,1.8-1,2.3c-0.6,0.6-1.6,1.3-3.3,1.3c-2.7,0-4.7-2.1-4.7-4.8 s2.1-4.8,4.7-4.8c1.4,0,2.5,0.6,3.3,1.3l1.3-1.3c-1.1-1-2.5-1.8-4.5-1.8c-3.6,0-6.7,3-6.7,6.6c0,3.6,3.1,6.6,6.7,6.6 c2,0,3.4-0.6,4.6-1.9c1.2-1.2,1.6-2.9,1.6-4.2c0-0.4,0-0.8-0.1-1.1H47.9z M93.2,25.1c-0.4-1-1.4-2.7-3.6-2.7c-2.2,0-4,1.7-4,4.3 c0,2.4,1.8,4.3,4.2,4.3c1.9,0,3.1-1.2,3.5-1.9l-1.4-1c-0.5,0.7-1.1,1.2-2.1,1.2c-1,0-1.6-0.4-2.1-1.3l5.7-2.4L93.2,25.1z M87.4,26.5c0-1.6,1.3-2.5,2.2-2.5c0.7,0,1.4,0.4,1.6,0.9L87.4,26.5z M82.8,30.7h1.9V18.2h-1.9V30.7z M79.7,23.4L79.7,23.4 c-0.5-0.5-1.3-1-2.3-1c-2.1,0-4.1,1.9-4.1,4.3c0,2.4,1.9,4.2,4.1,4.2c1,0,1.8-0.5,2.2-1h0.1v0.6c0,1.6-0.9,2.5-2.3,2.5 c-1.1,0-1.9-0.8-2.1-1.5l-1.6,0.7c0.5,1.1,1.7,2.5,3.8,2.5c2.2,0,4-1.3,4-4.4v-7.6h-1.8V23.4z M77.6,29.2c-1.3,0-2.4-1.1-2.4-2.6 c0-1.5,1.1-2.6,2.4-2.6c1.3,0,2.3,1.1,2.3,2.6C79.9,28.2,78.9,29.2,77.6,29.2z M102,18.2h-4.5v12.5h1.9v-4.7h2.6 c2.1,0,4.1-1.5,4.1-3.9S104,18.2,102,18.2z M102,24.2h-2.7v-4.3h2.7c1.4,0,2.2,1.2,2.2,2.1C104.2,23,103.4,24.2,102,24.2z M113.6,22.4c-1.4,0-2.8,0.6-3.3,1.9l1.7,0.7c0.4-0.7,1-0.9,1.7-0.9c1,0,1.9,0.6,2,1.6v0.1c-0.3-0.2-1.1-0.5-1.9-0.5 c-1.8,0-3.6,1-3.6,2.8c0,1.7,1.5,2.8,3.1,2.8c1.3,0,1.9-0.6,2.4-1.2h0.1v1h1.8v-4.8C117.3,23.6,115.7,22.4,113.6,22.4z M113.3,29.2 c-0.6,0-1.5-0.3-1.5-1.1c0-1,1.1-1.3,2-1.3c0.8,0,1.2,0.2,1.7,0.4C115.4,28.4,114.4,29.2,113.3,29.2z M123.9,22.7l-2.1,5.4h-0.1 l-2.2-5.4h-2l3.3,7.6l-1.9,4.2h1.9l5.1-11.8H123.9z M107.1,30.7h1.9V18.2h-1.9V30.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.966,
    y1: 173.957,
    x2: 5.184,
    y2: 157.174,
    gradientTransform: "matrix(1 0 0 -1 0 183.3333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10.6,8.2c-0.3,0.3-0.5,0.8-0.5,1.4v22.1c0,0.6,0.2,1.1,0.5,1.4l0.1,0.1l12.4-12.4v-0.1v-0.1L10.6,8.2 L10.6,8.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.001,
    y1: 162.665,
    x2: 9.804,
    y2: 162.665,
    gradientTransform: "matrix(1 0 0 -1 0 183.3333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M27.2,24.9l-4.1-4.1v-0.1v-0.1l4.1-4.1l0.1,0.1l4.9,2.8c1.4,0.8,1.4,2.1,0,2.9L27.2,24.9L27.2,24.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.994,
    y1: 160.371,
    x2: 2.235,
    y2: 137.612,
    gradientTransform: "matrix(1 0 0 -1 0 183.3333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M27.3,24.9l-4.2-4.2L10.6,33.1c0.5,0.5,1.2,0.5,2.1,0.1L27.3,24.9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.464,
    y1: 182.49,
    x2: 17.627,
    y2: 172.328,
    gradientTransform: "matrix(1 0 0 -1 0 183.3333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M27.3,16.4L12.7,8.1c-0.9-0.5-1.6-0.4-2.1,0.1l12.5,12.5L27.3,16.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M27.2,24.8L12.7,33c-0.8,0.5-1.5,0.4-2,0l0,0l-0.1,0.1l0,0l0.1,0.1l0,0c0.5,0.4,1.2,0.5,2,0L27.2,24.8 L27.2,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M10.6,33c-0.3-0.3-0.5-0.8-0.5-1.4v0.1c0,0.6,0.2,1.1,0.5,1.4V33L10.6,33z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M32.2,22l-5,2.8l0.1,0.1l4.9-2.8c0.7-0.4,1-0.9,1-1.4l0,0C33.2,21.1,32.8,21.6,32.2,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M12.7,8.3l19.5,11.1c0.6,0.4,1,0.8,1,1.3l0,0c0-0.5-0.3-1-1-1.4L12.7,8.1c-1.4-0.8-2.5-0.1-2.5,1.5v0.1 C10.1,8.2,11.3,7.5,12.7,8.3z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M41.5,13.7v-6h1.8c0.9,0,1.7,0.3,2.2,0.8c0.6,0.6,0.8,1.3,0.8,2.2c0,0.9-0.3,1.6-0.8,2.2 c-0.6,0.6-1.3,0.8-2.2,0.8H41.5z M42.3,12.9h1.1c0.7,0,1.2-0.2,1.6-0.6c0.4-0.4,0.6-1,0.6-1.7c0-0.7-0.2-1.3-0.6-1.7 c-0.4-0.4-1-0.6-1.6-0.6h-1.1V12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M47.5,13.7v-6h0.8v6H47.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M51.3,13.8c-0.4,0-0.9-0.1-1.3-0.4c-0.4-0.3-0.7-0.7-0.8-1.2l0.7-0.3c0.1,0.3,0.3,0.6,0.5,0.8 c0.3,0.2,0.6,0.3,0.9,0.3c0.3,0,0.6-0.1,0.9-0.3c0.2-0.2,0.4-0.4,0.4-0.7c0-0.3-0.1-0.6-0.4-0.8c-0.2-0.2-0.6-0.4-1.1-0.5 c-0.5-0.2-0.9-0.4-1.2-0.6c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.8,0.5-1.1c0.3-0.3,0.8-0.5,1.3-0.5c0.5,0,0.9,0.1,1.2,0.4 c0.3,0.3,0.5,0.5,0.6,0.8L52.4,9c-0.1-0.2-0.2-0.4-0.4-0.5c-0.2-0.2-0.5-0.2-0.8-0.2c-0.3,0-0.5,0.1-0.8,0.2 c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.2,0.1,0.4,0.3,0.6c0.2,0.2,0.5,0.3,0.9,0.4c0.3,0.1,0.5,0.2,0.7,0.3c0.2,0.1,0.4,0.2,0.6,0.4 c0.2,0.1,0.4,0.3,0.5,0.6c0.1,0.2,0.2,0.5,0.2,0.8s-0.1,0.6-0.2,0.8c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.4,0.2-0.6,0.3 S51.5,13.8,51.3,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M55.2,13.7h-0.8v-6h2c0.5,0,0.9,0.2,1.3,0.5c0.4,0.3,0.6,0.8,0.6,1.3c0,0.5-0.2,0.9-0.6,1.3 c-0.4,0.3-0.8,0.5-1.3,0.5h-1.3V13.7z M55.2,10.5h1.3c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7 c-0.2-0.2-0.5-0.3-0.8-0.3h-1.3V10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M64.2,12.9c-0.6,0.6-1.3,0.9-2.2,0.9c-0.9,0-1.6-0.3-2.2-0.9c-0.6-0.6-0.9-1.3-0.9-2.2s0.3-1.6,0.9-2.2 c0.6-0.6,1.3-0.9,2.2-0.9c0.9,0,1.6,0.3,2.2,0.9c0.6,0.6,0.9,1.3,0.9,2.2C65.1,11.5,64.8,12.3,64.2,12.9z M60.4,12.4 c0.4,0.4,1,0.7,1.6,0.7c0.6,0,1.2-0.2,1.6-0.7c0.4-0.4,0.7-1,0.7-1.7c0-0.7-0.2-1.3-0.7-1.7c-0.4-0.4-1-0.7-1.6-0.7 c-0.6,0-1.2,0.2-1.6,0.7c-0.4,0.4-0.7,1-0.7,1.7C59.7,11.4,59.9,11.9,60.4,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M66.2,13.7v-6h0.9l2.9,4.7h0l0-1.2V7.7h0.8v6H70l-3.1-4.9h0l0,1.2v3.7H66.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M72.2,13.7v-6h0.8v6H72.2z M72.9,7.2h-0.7l0.4-1.1h0.8L72.9,7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M75.8,13.7l-2.1-6h0.9l1.6,4.9h0l1.7-4.9h0.9l-2.2,6H75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M83.2,8.4h-2.7v1.9h2.5V11h-2.5v1.9h2.7v0.7h-3.5v-6h3.5V8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M84.4,13.7v-6h0.8v5.3h2.6v0.7H84.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M90.7,13.7v-6h0.9l2.9,4.7h0l0-1.2V7.7h0.8v6h-0.8l-3.1-4.9h0l0,1.2v3.7H90.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M101.6,12.9c-0.6,0.6-1.3,0.9-2.2,0.9c-0.9,0-1.6-0.3-2.2-0.9c-0.6-0.6-0.9-1.3-0.9-2.2s0.3-1.6,0.9-2.2 c0.6-0.6,1.3-0.9,2.2-0.9c0.9,0,1.6,0.3,2.2,0.9c0.6,0.6,0.9,1.3,0.9,2.2C102.5,11.5,102.2,12.3,101.6,12.9z M97.8,12.4 c0.4,0.4,1,0.7,1.6,0.7c0.6,0,1.2-0.2,1.6-0.7c0.4-0.4,0.7-1,0.7-1.7c0-0.7-0.2-1.3-0.7-1.7c-0.4-0.4-1-0.7-1.6-0.7 c-0.6,0-1.2,0.2-1.6,0.7c-0.4,0.4-0.7,1-0.7,1.7C97.1,11.4,97.4,11.9,97.8,12.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisponivelGooglePlay);
export default __webpack_public_path__ + "static/media/disponivel-google-play.7d954378351a608699483c1dd20b5e7b.svg";
export { ForwardRef as ReactComponent };